import { useState } from "react";
import { DocumentExtractionService } from "../data/services/document-extraction.service";
import {
  ExtractionResult,
  UserContext
} from "../data/models/document-extraction.model";

interface UseDocumentExtractionProps {
  onSuccess?: (result: ExtractionResult) => void;
  onError?: (error: string) => void;
}

/**
 * Custom hook for handling document extraction operations
 */
export const useDocumentExtraction = ({
  onSuccess,
  onError
}: UseDocumentExtractionProps = {}) => {
  const [isExtracting, setIsExtracting] = useState(false);

  const extractDocument = async (
    currentConfig: any,
    selectedModel: string,
    userContext: UserContext
  ): Promise<ExtractionResult> => {
    setIsExtracting(true);

    try {
      const result = await DocumentExtractionService.reextractDocument(
        currentConfig,
        selectedModel,
        userContext
      );

      if (result.success && onSuccess) {
        onSuccess(result);
      } else if (!result.success && onError) {
        onError(result.error || "Unknown error occurred");
      }

      return result;
    } catch (error) {
      const errorMessage = `Extraction failed: ${(error as Error).message}`;
      if (onError) {
        onError(errorMessage);
      }
      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setIsExtracting(false);
    }
  };

  return {
    extractDocument,
    isExtracting
  };
};
